import { Autocomplete, Box, TextField} from "@mui/material"
import { IOSSwitch } from "../../../../../../core/global/forms/CstmToggle"
import { useMemo } from "react"

export const Fields = ({ match, categoryType, concernForm, ctgyTypeList, handleInputConcern, teamList }) => {

    const sortedCtgy = useMemo(() => {
        return [...ctgyTypeList.data].sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );
        }, [ctgyTypeList.data]);
    
    return (
        <Box height="100%" width="100%" p={2} display="flex" flexDirection="column" bgcolor="#FFFFFF" alignItems="center" mt={2} borderRadius="10px">
            <Box width="100%" display="flex" flexDirection="column" alignItems="center"  >
                    <Box  width="100%" fontSize="14px" fontWeight={600} >
                        <Box  mb="8px" mt="20px">Type of Concern *</Box>
                        <Autocomplete 
                            disablePortal
                            blurOnSelect
                            noOptionsText="No Result"
                            name="type"
                            autoHighlight={true}
                            options={categoryType || [] }
                            getOptionLabel={(data) => (data.name)}
                            onChange={(e, val)=>handleInputConcern(e, val, 'type')}
                            value={concernForm.type ? categoryType.find((f) => f.id === concernForm.type) || null : null}
                            renderInput={(params) => (
                                <TextField fullWidth  sx={{"& .MuiOutlinedInput-root": {height: "40px"},}} {...params} inputProps={{...params.inputProps,autoComplete: 'off',sx:{ height: 12, p:0 ,'& input':{height:"10px",lineHeight:'12px', p:'0 12px'}}}} />
                            )}
                        />
                    </Box>
                    <Box  width="100%" fontSize="14px" fontWeight={600} >
                        <Box  mb="8px" mt="20px">Category *</Box>
                        <Autocomplete 
                            disablePortal
                            blurOnSelect
                            noOptionsText="No Result"
                            name="category"
                            autoHighlight={true}
                            options={sortedCtgy}
                            // options={ctgyTypeList.data || []}
                            getOptionLabel={(data) => (data.name)}
                            onChange={(e, val)=>handleInputConcern(e, val, 'category')}
                            value={concernForm.category ? ctgyTypeList.data.find((f) => f.id === concernForm.category) || null : null}
                            renderInput={(params) => (
                                <TextField fullWidth  sx={{"& .MuiOutlinedInput-root": {height: "40px"},}}  {...params} inputProps={{...params.inputProps,autoComplete: 'off',sx:{ height: 12, p:0 ,'& input':{height:"10px",lineHeight:'12px', p:'0 12px'}} }} />
                            )}
                            />
                    </Box>
                <Box  width="100%" fontSize="14px" fontWeight={600} >
                        <Box  mb="8px" mt="20px">Team *</Box>
                        <Autocomplete 
                            disablePortal
                            blurOnSelect
                            noOptionsText="No Result"
                            name="team"
                            autoHighlight={true}
                            options={teamList.data || []}
                            getOptionLabel={(data) => (data.name)}
                            onChange={(e, val)=>handleInputConcern(e, val, 'team')}
                            // value={concernForm.team === '' ? null : teamList.data.find((f) => f.id === concernForm.team ? {...f} : null)}
                            value={teamList.data.find((f) => f.id === concernForm.team) || null}
                            renderInput={(params) => (
                                <TextField fullWidth sx={{"& .MuiOutlinedInput-root": {height: "40px"},}}  {...params} inputProps={{...params.inputProps,autoComplete: 'off',sx:{ height: 12, p:0 ,'& input':{height:"10px",lineHeight:'12px', p:'0 12px'}}
                                }} />
                            )}
                            />
                    </Box>
            
                    <Box width="100%" display="flex" flexDirection="column" fontSize="14px" fontWeight={600} >
                        <Box  mb="8px" mt="20px">Details *</Box>
                        <TextField fullWidth multiline rows={2}  name="details" onChange={(e)=>handleInputConcern(e)} />
                    </Box>
            </Box>
            {
                match.params === 'update' &&
                    <Box height="100%" width="100%" display="flex" justifyContent="flex-end" gap={1} p="16px 16px 0px 16px">
                        <IOSSwitch name="active" />
                        <Box>Active</Box>
                    </Box>
            }
               
        </Box>
    )
}